export default "__VITE_ASSET__9c6a7c51__"